(function ($) {
	$(function () {
		let countSlides = 1;
		if($(window).width() > 700) {
            countSlides = 2;
		}
		// if($('.news__slider .newsBox').length > 1)
			$('.news__slider').owlCarousel({
			items: countSlides,
			margin: 40,
			nav: true,
			navText: [],
			dots: false
		});
	});
})(jQuery);
